import Layout from '@/layout'

const aboutRouter = {
    path: '/about',
    component: Layout,
    meta: {
        title: '关于我们'
    },
    children: [
        {
            path: '',
            name: 'About',
            component: () => import('@/views/about/index')
        },
        {
            path: 'wtic',
            name: 'AboutWtic',
            component: () => import('@/views/about/wtic/index')
        }
    ]
}

export default aboutRouter